import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { ForwardedRef, PropsWithChildren } from 'react';

import checked from '@/assets/icons/checked-icn-lg.svg';
import chevrone from '@/assets/icons/chevrone-icn-md.svg';

import styles from './Mission.module.scss';

type MissionProps = {
  name: string;
  icon: string;
  className?: string;
  completed?: boolean;
  missionBar?: string | JSX.Element;
  missionFooter?: string | JSX.Element;
  onClick?: VoidFunction;
  externalRef?: ForwardedRef<HTMLAnchorElement | null>;
};

export const MissionItem = observer<PropsWithChildren>(({ children }) => (
  <div className={styles['mission__item']}>{children}</div>
));

const MissionBar = observer<PropsWithChildren>(({ children }) => (
  <div className={styles['mission__bar']}>{children}</div>
));

const MissionFooter = observer<PropsWithChildren>(({ children }) => (
  <div className={styles['mission__footer']}>{children}</div>
));

export const Mission = observer<MissionProps>(
  ({
    name,
    missionBar,
    missionFooter,
    icon,
    completed,
    className,
    onClick,
    externalRef,
  }) => {
    console.log(missionBar, 'missionBar');
    return (
      <a
        className={clsx(styles.mission, className, {
          [styles['mission--completed']]: completed,
        })}
        onClick={onClick}
        ref={externalRef}
      >
        <div className={styles['mission__wrap']}>
          <div className={styles['mission__icn']}>
            <img loading="lazy" src={icon} alt="mission icon" />
          </div>
          <div className={styles['mission__main']}>
            <div className={styles['mission__name']}>{name}</div>
            {missionBar && <MissionBar>{missionBar}</MissionBar>}
          </div>
          <div className={styles['mission__arrow']}>
            <img src={completed ? checked : chevrone} alt="chevrone" />
          </div>
        </div>
        {missionFooter && <MissionFooter>{missionFooter}</MissionFooter>}
      </a>
    );
  },
);
